import {Component, Injector, Input, ViewChild} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {ModalComponent} from '@components/modal/modal.component';
import {TechnicalDocumentsService} from '@providers/technical-documents/technical-documents.service';

@Component({
    providers: [
    ],
    selector: 'std-add-modal',
    templateUrl: './std-add-modal.component.html',
})
export class StdAddModalComponent extends FrontendFormComponent {
    @Input() group = '';
    @Input() type = ''; // Тип документации (по методам или по объектам)
    @ViewChild('modal') private modal: ModalComponent;

    public afterSaveMessage = 'Заявка на добавление вашей НТД отправлена администратору';

    constructor(
        injector: Injector,
        public formService: TechnicalDocumentsService,
    ) {
        super(injector);
    }

    init() {
        this.form = this._fb.group({
            text: [''],
            type: [this.type], // По методам или по объектам
            group: [this.group]
        });
    }

    onShowModal() {
        this.form.patchValue({
            group: this.group,
            type: this.type || ''
        });
    }

    onHideModal() {
        this.form.reset();
    }

    showModal(group) {
        this.group = group || '';
        this.modal.open();
    }

    afterSave() {
        super.afterSave();
        this.modal.close();
    }
}
